import { Injectable } from '@angular/core';
import { Adjustment } from '../model/adjustment';
import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { Observable } from 'rxjs';

@Injectable()
export class AdjustmentService {

    private baseUrl;

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    insertAdjustment(adjustment: Adjustment): Observable<Adjustment> {
        adjustment.baseAdjustmentPercent = adjustment.baseAdjustmentPercent * .01;
        adjustment.optionsAdjustmentPercent = adjustment.optionsAdjustmentPercent * .01;

        return this._http.post(this.baseUrl + '/api/adjustments/', JSON.stringify(adjustment))
            .map(x => {
                return this.mapAdjustments(x.json());
            })
            .catch(this._http.handleError);
    }

    updateAdjustment(adjustment: Adjustment): Observable<Adjustment> {
        adjustment.baseAdjustmentPercent = adjustment.baseAdjustmentPercent * .01;
        adjustment.optionsAdjustmentPercent = adjustment.optionsAdjustmentPercent * .01;

        return this._http.put(this.baseUrl + `/api/adjustments/${adjustment.adjustmentId}`, JSON.stringify(adjustment))
            .map(x => {
                return this.mapAdjustments(x.json());
            })
			.catch(this._http.handleError);
    }

    mapAdjustments(apiAdjustment): Adjustment {
        if (apiAdjustment !== undefined && apiAdjustment !== null) {
            let adjustment: Adjustment = new Adjustment();
            adjustment.quoteId = apiAdjustment.QuoteId;
            adjustment.adjustmentId = apiAdjustment.AdjustmentId;
            adjustment.sequenceNumber = apiAdjustment.SequenceNumber;
            adjustment.baseAdjustmentPercent = parseFloat((apiAdjustment.BaseAdjustmentPercent * 100).toFixed(2));
            adjustment.baseAdjustmentFlat = apiAdjustment.BaseAdjustmentFlat;
            adjustment.optionsAdjustmentPercent = parseFloat((apiAdjustment.OptionsAdjustmentPercent * 100).toFixed(2));
            return adjustment;
        } else {
            return undefined;
        }
    }

    getAdjustmentByQuote(quoteId: number, refresh = false): Observable<Adjustment> {
        return this._http.get(`${this.baseUrl}/api/adjustments/${quoteId}`)
            .map(x => {
                return this._mapAdjustments(x.json());
            })
            .catch(this._http.handleError);
    }

    geturlBasedOnBrowser(url) {
        let temp;
        window.navigator.userAgent.indexOf('Trident') > 0 ? temp = `${url}?rand=${Math.random()}` : temp = `${url}`;
        return temp;
    }

    _mapAdjustments(apiAdjustment): Adjustment {
        if (apiAdjustment !== undefined && apiAdjustment !== null) {
            let adjustment: Adjustment = new Adjustment();
            adjustment.quoteId = apiAdjustment.QuoteId;
            adjustment.adjustmentId = apiAdjustment.AdjustmentId;
            adjustment.sequenceNumber = apiAdjustment.SequenceNumber;
            adjustment.baseAdjustmentPercent = parseFloat((apiAdjustment.BaseAdjustmentPercent * 100).toFixed(2));
            adjustment.baseAdjustmentFlat = apiAdjustment.BaseAdjustmentFlat;
            adjustment.optionsAdjustmentPercent = parseFloat((apiAdjustment.OptionsAdjustmentPercent * 100).toFixed(2));
            return adjustment;
        } else {
            return undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/adjustments.service.ts